import { useSearchParams } from 'react-router-dom';

import { MY_CERTIFICATES_TABLE_PAGE_SIZE } from '../shared/constants/certificates.constant';

type MyCertificatesTableQueryState = {
  skip: number;
  size: number;
  sort: string | undefined;
  setParams: (params: Record<string, string | number | string[] | undefined>) => void;
};

const DEFAULT_SORT = 'validUntil-desc';

export const useMyCertificatesTableQueryParams = (): MyCertificatesTableQueryState => {
  const [sp, setSp] = useSearchParams();

  const skip =
    (Number(sp.get('page') ?? 1) - 1) * Number(sp.get('size') ?? MY_CERTIFICATES_TABLE_PAGE_SIZE);
  const size = Number(sp.get('size') ?? MY_CERTIFICATES_TABLE_PAGE_SIZE);

  const sort = sp.get('sort') ?? DEFAULT_SORT;

  const setParams = (params: Record<string, string | number | string[] | undefined>): void => {
    const next = new URLSearchParams(sp);

    Object.entries(params).forEach(([key, value]) => {
      if (value === undefined || (Array.isArray(value) && value.length === 0) || value === '') {
        next.delete(key);

        return;
      }

      if (Array.isArray(value)) {
        next.set(key, value.join(','));

        return;
      }

      next.set(key, String(value));
    });

    setSp(next, { replace: true });
  };

  return {
    skip,
    size,
    sort,
    setParams,
  };
};
